import { render } from "./Stairs.vue?vue&type=template&id=0bd8a794"
import script from "./Stairs.vue?vue&type=script&lang=js"
export * from "./Stairs.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__